import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=cd8a1d60"
import script from "./InventoryTable.vue?vue&type=script&lang=js"
export * from "./InventoryTable.vue?vue&type=script&lang=js"
import style0 from "./InventoryTable.vue?vue&type=style&index=0&id=cd8a1d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports